import React from "react";
import TextField from "@mui/material/TextField";
import {StudyLinks} from "../../gen/api";
import Grid from "@mui/material/Grid";
import {IconButton, Typography} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import {PlusOne} from "@mui/icons-material";

type Props = {
    handleNewLinkSubmit: (studyLink: StudyLinks) => void
}

function NewLinkAdd({handleNewLinkSubmit}: Props) {

  const [tempLinkData, setTempLinkData] = React.useState<any | null>({
    link: undefined,
    formName: undefined
  });

  const handleNewLink = (event: any) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name")
    const fieldValue = event.target.value;

    const newFormData = {...tempLinkData}
    newFormData[fieldName] = fieldValue

    setTempLinkData(newFormData)
  }

  const addLink = () => {
      handleNewLinkSubmit(tempLinkData);
    setTempLinkData({
      link: undefined,
      formName: undefined
    });
  }

  return (
      <Grid container spacing={2}>
        <Grid item xs={3} alignSelf="flex-end">
          <Typography>Neuen Link hinzufügen:</Typography>
        </Grid>
        <Grid item xs={3}>
          <TextField id="download-text" label="Name" variant="standard" required={true}
                     name="formName"
                     value={tempLinkData.formName || ""} onChange={handleNewLink}/>
        </Grid>
        <Grid item xs={3}>
          <TextField id="download-link" label="Link" variant="standard" required={true} name="link"
                     value={tempLinkData.link || ""} onChange={handleNewLink}/>
        </Grid>
        <Grid item xs={3} textAlign="end">

          <IconButton onClick={addLink}
                      disabled={!tempLinkData.link || !tempLinkData.formName}>
            <PlusOne/>
          </IconButton>
        </Grid>
      </Grid>
  );
}

export default NewLinkAdd;